import React from "react";

import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import {
  toggleCutOffTime,
  toggleCutOffEnable,
  toggleNotificationOnDesktop,
  toggleScheduleStartTime
} from "store/actions";

import Tooltip from "App/common/ui/Tooltip";
import { TOOLTIPS } from "consts";
import { CONTENT } from "consts";
import { outlineFocus } from "utils";
import { ReactComponent as InformationIcon } from "assets/images/app_svg/information.svg";
import { SPopupContext } from "../../../../../common/hoc/SlidingPopup/index";

function Advanced(props) {
  const { sPopupMethods } = React.useContext(SPopupContext);
  const hours = [];
  const minutes = [];

  if (props.cutOffTime) {
    for (let i = 0; i <= 23; i++) {
      hours.push(
        <option key={i} value={i}>
          {i > 9 ? "" + i : "0" + i}
        </option>
      );
    }
    for (let i = 0; i <= 55; i = i + 5) {
      minutes.push(
        <option key={i} value={i}>
          {i > 9 ? "" + i : "0" + i}
        </option>
      );
    }
  }

  const handleInput = (e, limit) => {
    let val = e.target.value.replace(/\D/g, "");
    if (val.length > 2) {
      val = val.slice(-2);
    }
    if (val === "") {
      val = "00";
    }
    let num = Number(val);
    if (num > limit) {
      num = num % 10; // take last digit only
    }
    const formatted = String(num).padStart(2, "0");
    e.target.value = formatted;
  };

  const handlestartBackupImmediatelyPopup = () => {
    if (props.backupProgress || props.imageRestoreProgress)
      sPopupMethods.openPopup(
        props.backupProgress
          ? "schedulerDisableStartBckupImme"
          : props.imageRestoreProgress
          ? "schedulerDisableStartBckupImmeRestore"
          : "",
        {
          execute: () => {
            sPopupMethods.closePopup();
          },
          cancel: false,
          secondExecute: () => {
            sPopupMethods.closePopup();
          }
        }
      );
    else {
      props.toggleScheduleDevice("startBackupImmediately");
      const now = new Date();
      const currentSeconds =
        now.getHours() * 3600 + now.getMinutes() * 60 + now.getSeconds();
      props.toggleScheduleStartTime(currentSeconds);
    }
  };

  return (
    <div
      className={`schedule_backup_advance transparent_layer_schedule ${
        props.currentTypeKey === "NO_SCHEDULE" ? "layer_active" : ""
      }`}
    >
      <div className="transparent_layer" />

      <div className="input_checkboxw just_flex">
        <div
          className="check"
          onChange={() => handlestartBackupImmediatelyPopup()}
        >
          <input
            type="checkbox"
            className={
              "input_checkbox" +
              (props.scheduleInfo.advanced.startBackupImmediately &&
              window.browserName === "ie"
                ? " ie_checked"
                : "")
            }
            id="schedule_backup_6"
            defaultChecked={props.scheduleInfo.advanced.startBackupImmediately}
            tabIndex={0}
            onFocus={() => {
              outlineFocus("schedule_backup_6_label", 1);
            }}
            onBlur={() => {
              outlineFocus("schedule_backup_6_label", 0);
            }}
          />
          <label
            htmlFor="schedule_backup_6"
            id="schedule_backup_6_label"
          ></label>
        </div>
        <p
          className="checkbox_p"
          onClick={() => handlestartBackupImmediatelyPopup()}
        >
          {CONTENT.backupSettings.backupSchedule.advance.startBackupImmediately}
        </p>
      </div>

      <div className="input_checkboxw cut_off_row just_flex cutoff-blk">
        <div className="check">
          <input
            type="checkbox"
            className="input_checkbox"
            id="schedule_backup_1"
            defaultChecked={props.cutOffTime.isEnabled}
            onChange={() =>
              props.toggleCutOffEnable(!props.cutOffTime.isEnabled)
            }
            tabIndex={0}
            onFocus={() => {
              outlineFocus("schedule_backup_1_label", 1);
            }}
            onBlur={() => {
              outlineFocus("schedule_backup_1_label", 0);
            }}
          />
          <label htmlFor="schedule_backup_1" id="schedule_backup_1_label" />
        </div>
        <p
          className="checkbox_p"
          onClick={() => props.toggleCutOffEnable(!props.cutOffTime.isEnabled)}
        >
          Cut-off Time:{" "}
        </p>
        <div className="cow_box ">
          <div
            className={`cutt-off_wrap flex_align ${
              !props.cutOffTime.isEnabled ? "transparent_layer_wrap" : ""
            }`}
          >
            <div class="transparent_layer" />
            <div className="hours_mins_wrap hours_min_seconds_wrap flex_align ">
              <div className="id-hr-set">
                <input
                  type="number"
                  min={0}
                  max={23}
                  placeholder="HH"
                  onChange={e => props.toggleCutOffTime(e.target.value, "hr")}
                  onInput={e => handleInput(e, 23)}
                  value={Math.trunc(props.cutOffTime.value / 3600)}
                />
              </div>
              <span class="id-min-set">
                <input
                  type="number"
                  min={0}
                  max={59}
                  placeholder="MM"
                  onChange={e => props.toggleCutOffTime(e.target.value, "mn")}
                  onInput={e => handleInput(e, 59)}
                  value={Math.trunc((props.cutOffTime.value % 3600) / 60)}
                />
              </span>
              <span class="id-sec-set">
                <input
                  type="number"
                  min={0}
                  max={59}
                  placeholder="SS"
                  onChange={e => props.toggleCutOffTime(e.target.value, "ss")}
                  onInput={e => handleInput(e, 59)}
                  value={Math.trunc((props.cutOffTime.value % 3600) % 60)}
                />
              </span>
              <Tooltip {...TOOLTIPS.backupSettings.schedule.cutOff}>
                <span className="icon">
                  <InformationIcon />
                </span>
              </Tooltip>
            </div>
          </div>
        </div>
      </div>

      {/* Prevent sleep */}
      {/* <div className="input_checkboxw just_flex">
        <div
          className="check"
          onChange={() => {
            props.toggleScheduleDevice("preventSleep");
          }}
        >
          <input
            type="checkbox"
            className={
              "input_checkbox" +
              (props.scheduleInfo.advanced.preventSleep &&
              window.browserName === "ie"
                ? " ie_checked"
                : "")
            }
            id="schedule_backup_5"
            defaultChecked={props.scheduleInfo.advanced.preventSleep}
            tabIndex={0}
            onFocus={() => {
              outlineFocus("schedule_backup_5_label", 1);
            }}
            onBlur={() => {
              outlineFocus("schedule_backup_5_label", 0);
            }}
          />
          <label
            htmlFor="schedule_backup_5"
            id="schedule_backup_5_label"
          ></label>
        </div>
        <p
          className="checkbox_p"
          onClick={() => {
            props.toggleScheduleDevice("preventSleep");
          }}
        >
          {CONTENT.backupSettings.backupSchedule.advance.hibernate}
        </p>
      </div> */}

      {/* <div className="input_checkboxw just_flex">
        <div
          className="check"
          onChange={() => props.toggleScheduleDevice("performShutdown")}
        >
          <input
            type="checkbox"
            className="input_checkbox"
            id="schedule_backup_3"
            defaultChecked={props.scheduleInfo.advanced.performShutdown}
          />
          <label htmlFor="schedule_backup_3"></label>
        </div>
        <p className="checkbox_p">
          {CONTENT.backupSettings.backupSchedule.advance.shutdown}
        </p>
      </div> */}
      {/* temporary changes */}
      {/* <div className="input_checkboxw just_flex">
        <div
          className="check"
          onChange={() => {
            props.toggleNotificationOnDesktop();
          }}
        >
          <input
            type="checkbox"
            className={
              "input_checkbox" +
              (props.emailNotification.notifyOnDesktop &&
              window.browserName === "ie"
                ? " ie_checked"
                : "")
            }
            id="schedule_backup_7"
            defaultChecked={props.emailNotification.notifyOnDesktop}
            tabIndex={0}
            onFocus={() => {
              outlineFocus("schedule_backup_7_label", 1);
            }}
            onBlur={() => {
              outlineFocus("schedule_backup_7_label", 0);
            }}
          />
          <label
            htmlFor="schedule_backup_7"
            id="schedule_backup_7_label"
          ></label>
        </div>
        <p
          className="checkbox_p"
          onClick={() => {
            props.toggleNotificationOnDesktop();
          }}
        >
          {CONTENT.backupSettings.backupSchedule.advance.notifyOnDesktop}
        </p>
      </div> */}

      <div className="input_checkboxw just_flex">
        <div
          className="check"
          onChange={() => props.toggleScheduleDevice("runMissed")}
        >
          <input
            type="checkbox"
            className={
              "input_checkbox" +
              (props.scheduleInfo.advanced.runMissed &&
              window.browserName === "ie"
                ? " ie_checked"
                : "")
            }
            id="schedule_backup_2"
            defaultChecked={props.scheduleInfo.advanced.runMissed}
            tabIndex={0}
            onFocus={() => {
              outlineFocus("schedule_backup_2_label", 1);
            }}
            onBlur={() => {
              outlineFocus("schedule_backup_2_label", 0);
            }}
          />
          <label htmlFor="schedule_backup_2" id="schedule_backup_2_label" />
        </div>
        <p
          className="checkbox_p"
          onClick={() => props.toggleScheduleDevice("runMissed")}
        >
          {CONTENT.backupSettings.backupSchedule.advance.startup}
        </p>
      </div>

      <div className="input_checkboxw just_flex">
        <div
          className="check"
          onChange={() => props.toggleScheduleDevice("onWakeup")}
        >
          <input
            type="checkbox"
            className={
              "input_checkbox" +
              (props.scheduleInfo.advanced.onWakeup.checked &&
              window.browserName === "ie"
                ? " ie_checked"
                : "")
            }
            id="schedule_backup_3"
            defaultChecked={props.scheduleInfo.advanced.onWakeup.checked}
            tabIndex={0}
            onFocus={() => {
              outlineFocus("schedule_backup_3_label", 1);
            }}
            onBlur={() => {
              outlineFocus("schedule_backup_3_label", 0);
            }}
          />
          <label htmlFor="schedule_backup_3" id="schedule_backup_3_label" />
        </div>
        <p
          className="checkbox_p"
          onClick={() => props.toggleScheduleDevice("onWakeup")}
        >
          {CONTENT.backupSettings.backupSchedule.advance.wakeup}
        </p>
      </div>

      {/* <div
        className={[
          "login_pass",
          "just_flex transparent_layer_wrap",
          "transparent_layer_login_pass",
          props.scheduleInfo.advanced.onWakeup.checked ? "layer_active" : null,
        ].join(" ")}
      >
        <div className="transparent_layer" />
        <div className="lp_item just_flex">
          <p>{CONTENT.backupSettings.backupSchedule.advance.creds.username}</p>
          <div className="err_msg_wrap">
            <input
              type="text"
              className="input_text"
              value={props.scheduleInfo.advanced.onWakeup.userName}
              onChange={(e) =>
                props.toggleScheduleLoginDetails("userName", e.target.value)
              }
            />
            {!sPopupState.validation.status &&
              sPopupState.validation.params.emptyUserName && (
                <div>
                  <span className="error-msg active">
                    {sPopupState.validation.params.emptyUserName.msg}
                  </span>
                </div>
              )}
          </div>
        </div>
        <div className="lp_item just_flex">
          <p>{CONTENT.backupSettings.backupSchedule.advance.creds.pwd}</p>
          <div className="err_msg_wrap">
            <input
              type="password"
              className="input_password"
              value={props.scheduleInfo.advanced.onWakeup.password}
              onChange={(e) =>
                props.toggleScheduleLoginDetails("password", e.target.value)
              }
            />
            {!sPopupState.validation.status &&
              sPopupState.validation.params.emptyPassword && (
                <div>
                  <span className="error-msg active">
                    {sPopupState.validation.params.emptyPassword.msg}
                  </span>
                </div>
              )}
          </div>
        </div>
      </div> */}
    </div>
  );
}

function mapStateToProps(state) {
  return {
    cutOffTime: state.backupSettings.cutOffTime,
    emailNotification: state.backupSettings.emailNotification
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      toggleCutOffTime,
      toggleCutOffEnable,
      toggleNotificationOnDesktop,
      toggleScheduleStartTime
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Advanced);
